import React from "react";
import TheNav from "../Components/navbar";
import FartsInTheBag from "../images/IMG_4925.jpg"
import SEO from "../Components/SEO";

export default function Return() {
  return (
    <>
      <SEO
        title="Transaction Error | Kre8"
        description="Private Kre8 payment refresh page."
        canonicalPath="/refresh"
        noindex
      />
      <TheNav />
      <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <p className="text-base font-semibold text-indigo-600">Link Error</p>
          <h1 className="mt-4 text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-7xl">
            There is an error with your transaction
          </h1>
          <p className="mt-6 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8">
            Please try again.
          </p>
          <img style={{ marginTop: "12%", margin: "auto", width: "30vw" }} src={FartsInTheBag} fetchPriority="high"
            decoding="async"
            loading="eager" alt="Valkyrae" />
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <a
              href="/"
              className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Go back home
            </a>
            <a href="/orders" className="text-sm font-semibold text-gray-900">
              View your orders <span aria-hidden="true">&rarr;</span>
            </a>
          </div>
        </div>
      </main>
    </>
  )
}
